module.exports = __webpack_public_path__ + "static/img/省级创新创业大赛优秀企业.a551f753.jpg";